export const DELIVERED_BY = {
  MERCHANT: 'MERCHANT',
  IFOOD: 'IFOOD',
};

export const deliveredMethodsSorter = {
  [DELIVERED_BY.MERCHANT]: 1,
  [DELIVERED_BY.IFOOD]: 2,
};
